import type { PayoutStatus } from "@/types/admin-portal/bonus-ro";

export const PAYOUT_STATUSES: PayoutStatus[] = [
	"DRAFT",
	"APPROVED",
	"PAID",
	"CANCELLED",
];

/** Each action is also the last segment of its backend path. */
export type PayoutAction = "approve" | "paid" | "cancel";

/**
 * The actions each status allows, mirroring the backend's transitions: DRAFT → APPROVED →
 * PAID, and CANCELLED from either before PAID. Who approves and who pays may be the same
 * admin; the row shows both names instead.
 */
export const PAYOUT_ACTIONS: Record<PayoutStatus, readonly PayoutAction[]> = {
	DRAFT: ["approve", "cancel"],
	APPROVED: ["paid", "cancel"],
	PAID: [],
	CANCELLED: [],
};

export const payoutTransitionUrl = (
	template: string,
	id: string,
	action: PayoutAction,
) => template.replace(":id", id).replace(":transition", action);

/** A new payout's amount: the balance when there is one to pay, else left empty. */
export const payoutPrefill = (balance: number) =>
	balance > 0 ? String(balance) : "";

/** YYYY-MM-DD days compare as strings; either end may be left empty. */
export const periodInvalid = (start: string, end: string) =>
	start !== "" && end !== "" && end < start;
